import React from 'react';
import { motion } from 'framer-motion';
/**
 * StatsMarquee — donker, continu lopend "feiten"-bandje onder de hero.
 * Toont de zes belangrijkste proof points in 5 seconden.
 */
const ITEMS = [{
  value: '10',
  unit: 'vakken'
}, {
  value: '100+',
  unit: 'leerdoelen'
}, {
  value: '38',
  unit: 'vraagtypes'
}, {
  value: '55',
  unit: 'hulpmiddelen'
}, {
  value: '8',
  unit: 'kwaliteitschecks'
}, {
  value: '16',
  unit: 'niveaus'
}, {
  value: 'groep 6-8',
  unit: 'curriculum'
}, {
  value: '0',
  unit: 'reclame'
}];
export function StatsMarquee() {
  // Triplet voor naadloze loop
  const items = [...ITEMS, ...ITEMS, ...ITEMS];
  return <section aria-label="Snelle feiten over Meester djay" className="relative bg-slate-900 text-white py-6 overflow-hidden border-y border-slate-800" data-id="element-701">
      <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-slate-900 to-transparent z-10 pointer-events-none" data-id="element-702" />
      <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-slate-900 to-transparent z-10 pointer-events-none" data-id="element-703" />

      <motion.div className="flex gap-12 whitespace-nowrap" animate={{
      x: ['0%', '-33.333%']
    }} transition={{
      duration: 40,
      repeat: Infinity,
      ease: 'linear'
    }} data-id="element-704">
        {items.map((it, i) => <div key={i} className="flex items-center gap-3 shrink-0" data-id="element-705">
            <div data-id="element-706">
              <div className="text-2xl font-black leading-none text-orange-400" data-id="element-707">
                {it.value}
              </div>
              <div className="text-[10px] font-bold uppercase tracking-widest text-slate-400 mt-0.5" data-id="element-708">
                {it.unit}
              </div>
            </div>
            <span className="text-slate-700 text-2xl mx-4" aria-hidden="true" data-id="element-709">
              ·
            </span>
          </div>)}
      </motion.div>
    </section>;
}